import { Button } from '@inflearn/ds-react';

const LEAVE_REQUEST_FORM_URL = 'https://forms.gle/rcEqni6GzyvsXaUQ9';

export const LeaveRequestButton = () => {
  return (
    <Button
      fullWidth
      component="a"
      href={LEAVE_REQUEST_FORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      variant="filled"
      color="red"
      size="md"
      radius="md"
    >
      탈퇴 신청서 작성
    </Button>
  );
};
